export default "__VITE_ASSET__DP6QU55N__"